<template>
  <div id="rightInfo">
    <ul class="rightInfo">
      <!-- <li class="rightInfo-item">
        <el-popover style="background-color:#106e98 !important;" placement="left" width="110" trigger="hover" v-model="visibletime" >
          <span class="popoverText">{{basicInfo.workingHours}}</span>
          <a slot="reference"><i class="fa fa-clock-o fa-lg"></i></a>
        </el-popover>
      </li>
      <li class="rightInfo-item">
        <a target="_blank" :href='`http://wpa.qq.com/msgrd?v=3&uin=${basicInfo.qqAccount}&site=qq&menu=yes`' class="contact">
        <i class="fa fa-qq fa-lg"></i></a>
      </li>
      <li class="rightInfo-item">
        <el-popover placement="left" width="160" trigger="hover" v-model="visible">
          <img :src="basicInfo.weChatPublicNumberCode" alt>

          <a slot="reference"><i class="fa fa-qrcode fa-lg"></i></a>
        </el-popover>
      </li>-->

      <li class="rightInfo-item" @click="backTop">TOP</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "rightInfo",
  data() {
    return {
      scrollTop: 0,
      visible: false,
      visibletime: false
    };
  },
  computed: {
    basicInfo() {
      return this.$store.state.webInfo;
    }
  },
  props: ["leftTab"],
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      let top = document.documentElement.scrollTop; // 实现滚动效果

      const timeTop = setInterval(() => {
        document.documentElement.scrollTop = top -= 200;
        if (top <= 0) {
          clearInterval(timeTop); //清除定时器
        }
      }, 10);
      // let timer = setInterval(() => {
      //   let ispeed = Math.floor(-that.scrollTop / 5);
      //   document.documentElement.scrollTop = that.scrollTop + ispeed;
      //   document.body.scrollTop = that.scrollTop + ispeed;
      //   if (that.scrollTop === 0) {
      //     clearInterval(timer);
      //   }
      // }, 500);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
  scrollToTop() {
    const that = this;
    let scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
    that.scrollTop = scrollTop;
    if (that.scrollTop > 60) {
      that.btnFlag = true;
    } else {
      that.btnFlag = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  color: #fff;
}
a:hover {
  color: #c8c5b8;
}
.rightInfo {
  width: 42px;
  line-height: 42px;
  color: #fff;
  position: fixed;
  right: 0;
  bottom: 20%;
  text-align: center;
  z-index: 9;
}

.rightInfo-item {
  opacity: 0.9;
  background: #106e98;
  height: 42px;
  box-sizing: border-box;
  font-size: 14px;
  cursor: pointer;
  margin-bottom: 3px;
  border-radius: 3px;
}
.rightInfo-item:hover,
.el-button:hover,
.contact:hover {
  color: #c8c5b8 !important;
}
.contact {
  color: #fff;
}
.el-button {
  background: none;
  border: none;
  color: #fff;
  width: 42px;
  text-align: center;
  margin-left: -10px;
}
.el-button span {
}
/*.el-popover{*/
/*  text-align: center;*/
/*  background: #106e98 !important;*/
/*}*/
.el-button:focus,
.el-button:hover {
  border-color: none !important;
  background-color: none !important;
}
.popoverText {
  color: #fff;
}
</style>
<style>
.el-popover {
  text-align: center !important;
  background-color: #106e98 !important;
  color: #eeeeee;
  border: none;
  /* left: 1120px !important; */
}
.el-popper .popper__arrow,
.el-popper .popper__arrow::after {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/comment/rightInfo.vue